import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import Navbar from '../../Components/Logo/Navigation/Navbar/Navbar';
import SideDrawer from '../../Components/Logo/Navigation/SideDrawer/SideDrawer';
import LabelBottomNavigation from '../../Components/Logo/Navigation/BottomNavigation/BottomNav';
import GeoNotificationWatcher from '../../Components/Geo/GeoNotificationWatcher';
import LegacyUiTranslationBridge from '../../Components/I18n/LegacyUiTranslationBridge';
import NotificationCenter from '../../Components/Notifications/NotificationCenter';

const MainWrapper = styled.main`
  width: 100%;
  min-height: 100vh;
  padding-top: 4.6rem;

  @media (max-width: 56rem) {
    padding-top: calc(4.2rem + env(safe-area-inset-top));
    padding-bottom: ${({ $loggedIn }) => ($loggedIn ? 'calc(6.5rem + env(safe-area-inset-bottom))' : '0')};
  }
`;

const Layout = ({ children, loggedIn }) => (
  <>
    <Navbar loggedIn={loggedIn} />
    {loggedIn ? <NotificationCenter /> : null}
    <SideDrawer loggedIn={loggedIn} />
    {loggedIn ? <LabelBottomNavigation /> : null}
    {loggedIn ? <GeoNotificationWatcher /> : null}
    <MainWrapper $loggedIn={loggedIn}>{children}</MainWrapper>
    <LegacyUiTranslationBridge />
  </>
);

const mapStateToProps = ({ firebase }) => ({
  loggedIn: Boolean(firebase.auth && firebase.auth.uid),
});

export default connect(mapStateToProps)(Layout);
